module.exports = __webpack_public_path__ + "img/9788925551968.a7bc171a.jpg";